import React from "react";
import Typewriter from "typewriter-effect";
import { useLanguage } from "../../context/LanguageContext";

function Type() {
  const { language } = useLanguage();

  return (
    <Typewriter
      key={language}
      options={{
        strings:
          language === "id"
            ? [
                "produk Flutter",
                "pengalaman Android",
                "aplikasi web modern",
                "product thinking",
              ]
            : [
                "Flutter products",
                "Android experiences",
                "modern web apps",
                "product thinking",
              ],
        autoStart: true,
        loop: true,
        deleteSpeed: 50,
      }}
    />
  );
}

export default Type;
